export const DEFAULT_MAX_SIZE = 100 * 1000 * 1000; // 100 MB default

export const DEFAULT_ACCEPTED_FILE_TYPES = {
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
};
